import RequestMaster from '../RequestMaster'

export default class RequestComunicaciones extends RequestMaster {

    constructor() {
        super()
        this.URL_BASE = this.URL_BASE + '/comunicacion'
    }

    /**
     * Crea comunicaciones con los alumnos
     *
     * @param {FormData} params
     * @param {Function} callback
     * @param {Function} callbackError
     * @param {Function} callbackFinally
     */
    create(params, callback = () => { }, callbackError = () => { }, callbackFinally = () => { }) {
        const path = ""
        this.post(path, params, callback, callbackError, callbackFinally)
    }

}
